import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { FormType } from '@/models';
import { shouldShowRewards } from '@/helpers';

@Component({
  name: 'CmgAccountModalCreateAccountSignIn',
})
export default class CmgAccountModalCreateAccountSignIn extends Vue {

  get countryCode(): string {
    return this.$appStore.state.ui.countryProfile.countryCode;
  }

  get shouldShowRewards(): boolean {
    return shouldShowRewards(this.countryCode);
  }

  get guestAccountCreationHeadingText() {
    const cfValue = this.$services.config.getAccountModal()?.guestAccountCreationHeadline;
    return cfValue ? cfValue : '';
  }

  async onClickSignIn() {
    await this.$services.config.setLegalText();
    this.$services.ui.setModalVisibility('account', false);

    // Since DOM changes are batched, going from one modal to another modal will cause issues with watchers
    Vue.nextTick(() => {
      this.$services.ui.setModalVisibility('signIn', true);
    });
  }

  async onClickCreateAccount() {
    await this.$services.config.setLegalText();
    this.$services.ui.setModalVisibility('account', false);
    
    Vue.nextTick(() => {
      this.$services.ui.setModalVisibility('signIn', true, { type: FormType.CreateAccount });
    });
  }
}
